import request from '@src/api/request';
import { RequestConfig } from '@src/types/common.type';

import {
  CommResult,
  ModuleGetCatalogsRsp,
  ModuleGetPopularPostsRsp,
  ModuleGetPostContentRsp,
  ModuleSearchPostsReq,
  ModuleSearchPostsRsp,
} from './data-contracts';

/**
 * No description
 *
 * @tags SupportCenterApi
 * @name CatalogsList
 * @summary 获取目录树形结构
 * @request GET:/support/catalogs
 */
export const getSupportCatalogs = (
  query?: {
    /** 空-查询完整目录树 */
    platform?: 'publisher' | 'advertiser';
    /** 是否仅查询根目录 */
    root_only?: boolean;
  },
  params: RequestConfig = {},
): Promise<
  CommResult & {
    data: ModuleGetCatalogsRsp;
  }
> => request.get('/support/catalogs', query, params);
/**
 * No description
 *
 * @tags SupportCenterApi
 * @name ContentsList
 * @summary 根据文章ID查询完整内容
 * @request GET:/support/contents
 */
export const getSupportContents = (
  query: {
    /** 文章ID */
    post_id: string;
  },
  params: RequestConfig = {},
): Promise<
  CommResult & {
    data: ModuleGetPostContentRsp;
  }
> => request.get('/support/contents', query, params);
/**
 * No description
 *
 * @tags SupportCenterApi
 * @name PopularList
 * @summary 获取热门文档列表
 * @request GET:/support/popular
 */
export const getSupportPopular = (
  query?: {
    /** 空-查询所有 */
    platform?: 'publisher' | 'advertiser';
  },
  params: RequestConfig = {},
): Promise<
  CommResult & {
    data: ModuleGetPopularPostsRsp;
  }
> => request.get('/support/popular', query, params);
/**
 * No description
 *
 * @tags SupportCenterApi
 * @name SearchCreate
 * @summary 搜索文章
 * @request POST:/support/search
 */
export const postSupportSearch = (
  data: ModuleSearchPostsReq,
  params: RequestConfig = {},
): Promise<
  CommResult & {
    data: ModuleSearchPostsRsp;
  }
> => request.post('/support/search', data, params);
/**
 * No description
 *
 * @tags SupportAPI
 * @name TestList
 * @summary 测试接口
 * @request GET:/support/test
 */
export const getSupportTest = (params: RequestConfig = {}): Promise<any> => request.get('/support/test', null, params);
